module.exports = __webpack_public_path__ + "img/banner-fabrica.59903435.jpeg";